import React from 'react';
import { productBenefits } from '../../data/productBenefits';
import type { Product } from '../../types/product';
import { Reveal } from '../ui/Reveal';
export function WhyGood({
  product
}: {
  product: Product;
}) {
  const items = productBenefits[product.slug];
  if (!items?.length) return null;
  return <section className="bg-surface" aria-labelledby="why-good" data-id="element-341" data-mp="2eph08yxsbhd4">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8 lg:py-24" data-id="element-342" data-mp="20yu2pa3rfxim">
        <Reveal data-id="element-343" data-mp="20xiyj96eknqz">
          <h2 id="why-good" className="font-display text-4xl uppercase tracking-display text-ink sm:text-5xl" data-id="element-344" data-mp="20x0tpo5od17g">
            Waarom {product.name} <em className="italic text-pink" data-id="element-345" data-mp="1r164ubauy9w8">goed voor je is</em>
          </h2>
        </Reveal>
        <ul className="mt-10 grid gap-4 md:grid-cols-3 md:gap-6" data-id="element-346" data-mp="1vz7ooyg3yd8r">
          {items.map((b, i) => <li key={b.title} className="h-full" data-id="element-347" data-mp="1hzg60kenc8of" data-mpi={i}>
              <Reveal delay={i * 0.05} className="flex h-full flex-col rounded-3xl bg-white p-8" data-id="element-348" data-mp="1i0rh75af8ipk">
                <h3 className="font-display text-2xl tracking-display text-berry" data-id="element-349" data-mp="1my9h666gnnlf">{b.title}</h3>
                <p className="mt-3 text-[17px] font-light leading-relaxed text-muted" data-id="element-350" data-mp="p7lbht1sjen0">{b.text}</p>
              </Reveal>
            </li>)}
        </ul>
      </div>
    </section>;
}